<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{header}} </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <frg-form-input label="Titre" id="titre" type="text" placeholder="Ex: Recherche multi critère 1"
                            [formGroup]="formGroup" [control]="formGroup.get('titre')" class="patient-form-input"
                            required="true" ></frg-form-input>
                <div class="button-wrapper"> 
                    <frg-button (activated)="closeRechercheModal()" [backgroundColor]="'var(--darkest-primary)'"
                        [type]="'reset'">Quitter</frg-button>
                    <frg-button *ngIf="!isEdit" [type]="'submit'" [backgroundColor]="'var(--primary)'">Ajouter
                    </frg-button>
                    <frg-button *ngIf="isEdit" [type]="'submit'" [backgroundColor]="'var(--primary)'">Modifier
                    </frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>